import axios from 'axios';

type GetExcessivePaidFormData = {
    taxpayerCode: string;
    taxOrgCode: string;
    kbk: string;
};

export const getExcessivePaidForm = async (data: GetExcessivePaidFormData): Promise<string> => {
    return axios
        .post('/services/isnaportalsync/public/excessive-paid', data, {
            headers: {
                'X-Portal-Token': 'd0165516-04e0-4d5c-961a-18d45b8259ea',
                Accept: 'application/xml',
                'Content-Type': 'application/json',
            },
        })
        .then(({ data }) => data);
};

type SendExcessivePaidFormData = {
    signedRequest: string;
    taxpayerCode: string;
};

export const sendExcessivePaidForm = async ({
    signedRequest,
    taxpayerCode,
}: SendExcessivePaidFormData) => {
    return axios.post(
        '/services/isnaportalsync/public/excessive-paid',
        { taxpayerCode, signedRequest },
        {
            headers: {
                'X-Portal-Token': 'd0165516-04e0-4d5c-961a-18d45b8259ea',
            },
        }
    );
};
